import {
  AspectRatio,
  Box,
  Flex,
  HStack,
  SimpleGrid,
  Text,
  VStack
} from '@chakra-ui/react'

import Image from 'next/image'

const Item = ({
  title,
  src,
  ratio = 1 / 1
}: {
  title: string
  src: any
  ratio?: any
}) => {
  return (
    <VStack gap={2}>
      <VStack w="100%" minH="100px" justifyContent="center">
        <AspectRatio
          w={{
            base: '60px',
            sm: '80px',
            xl: '90px'
          }}
          ratio={ratio}
          position="relative"
        >
          <Image src={src} alt={title} fill />
        </AspectRatio>
      </VStack>
      <Text
        lineHeight={1.1}
        fontSize={{
          base: '14px',
          sm: '15px'
        }}
        textAlign="center"
        fontFamily="Inter"
        fontWeight={500}
        zIndex={100}
        maxW="150px"
      >
        {title}
      </Text>
    </VStack>
  )
}

const Effectiveness = () => {
  return (
    <VStack mt={10} alignItems="center">
      <HStack
        data-aos="fade-up"
        w={{
          base: '90%',
          sm: '80%',
          md: '70%',
          lg: 700
        }}
        gap={{
          base: 4,
          sm: 4,
          md: 8,
          lg: 10
        }}
      >
        <VStack>
          <AspectRatio
            w={{
              base: '70px',
              sm: '80px',
              md: '100px',
              lg: '120px'
            }}
            ratio={1 / 1}
            position="relative"
            style={{
              border: '3px solid #000',
              borderRadius: '50%'
            }}
          >
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/effect-one-1714037427759.png'
              }
              alt="new icon"
              fill
            />
          </AspectRatio>
          <AspectRatio
            w={{
              base: '70px',
              sm: '80px',
              md: '100px',
              lg: '120px'
            }}
            ratio={1 / 1}
            position="relative"
            style={{
              border: '3px solid #000',
              borderRadius: '50%'
            }}
          >
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/effect-two-1714037427761.png'
              }
              alt="new icon"
              fill
            />
          </AspectRatio>
          <AspectRatio
            w={{
              base: '70px',
              md: '100px',
              lg: '120px'
            }}
            ratio={1 / 1}
            position="relative"
          >
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/effect-three-1714037427760.png'
              }
              alt="new icon"
              fill
              style={{
                border: '3px solid #000',
                borderRadius: '50%'
              }}
            />
          </AspectRatio>
        </VStack>
        <Box>
          <Text
            lineHeight={1.1}
            fontSize={{
              base: '16px',
              sm: '20px',
              md: '24px',
              lg: '30px'
            }}
            textAlign="left"
            fontFamily="Inter"
            fontWeight={900}
            zIndex={100}
            color={'#4B7438'}
          >
            Health+ OralCare Mouthwash
          </Text>
          <Text
            fontSize={{
              base: '12px',
              sm: '16px',
              md: '18px',
              lg: '20px'
            }}
            lineHeight={{
              base: 1.3,
              md: 1.4
            }}
            textAlign="justify"
            fontWeight={400}
            zIndex={100}
            mt={{
              base: 2,
              sm: 4
            }}
          >
            Discover a powerful, natural solution for preventing tooth decay
            with our innovative formula. <br /> <br /> Harnessing the potency of
            Ginseng Flower Extract, revered as the &nbsp;
            <strong> 'sacred grass flower'</strong>, our product offers a blend
            of &nbsp;
            <strong>
              20 saponin active substances, 17 amino acids, 11 essential
              microelements, and 3 anticancer-active selenium compounds and
              proteins.
            </strong>
            &nbsp;Effective in preventing gum disease and deeply nourishing
            tooth and gum health, it provides a safe and holistic approach to
            oral care.
          </Text>
        </Box>
      </HStack>

      <Text
        data-aos="fade-up"
        textStyle="oralcareEffectivenessTittle"
        textAlign="left"
        textTransform="uppercase"
        color="#4B7438"
        mt={{
          base: 2,
          md: 4,
          xl: 10
        }}
      >
        EFFECTIVENESS
      </Text>

      <Flex
        data-aos="fade-up"
        flexDir={{
          base: 'column',
          md: 'row'
        }}
        w={{
          base: '70%',
          md: '100%'
        }}
        justifyContent="space-between"
        // alignItems="center"
        gap={{
          base: 4,
          md: 0
        }}
        mt={{
          base: 8,
          md: 10
        }}
      >
        <VStack flex={1} justifyContent="center" alignItems="center">
          <AspectRatio
            w={{
              base: '100%',
              md: '100%'
            }}
            ratio={1112 / 792}
            position="relative"
          >
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/effect-right-1714037427764.png'
              }
              alt="new icon"
              fill
            />
          </AspectRatio>
        </VStack>
        <VStack flex={1} justifyContent="center" alignItems="center">
          <AspectRatio
            w={{
              base: '70%',
              md: '100%'
            }}
            ratio={688 / 960}
            position="relative"
          >
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/three-bottle-1715151284733.png'
              }
              alt="group bottle"
              fill
            />
          </AspectRatio>
        </VStack>
        <VStack flex={1} justifyContent="center" alignItems="center">
          <AspectRatio
            w={{
              base: '100%',
              md: '100%'
            }}
            ratio={1112 / 792}
            position="relative"
          >
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/effect-left-1714037427761.png'
              }
              alt="new icon"
              fill
            />
          </AspectRatio>
        </VStack>
      </Flex>

      <SimpleGrid
        data-aos="fade-up"
        columns={{ base: 2, md: 4 }}
        gap={4}
        w={{
          base: '80%',
          md: '76%'
        }}
        mt={5}
      >
        <Item
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/tripple-icon-1714037427765.png'
          }
          title="Triple cleaning effect"
          ratio={997 / 859}
        />
        <Item
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/improve-health-1714037427766.png'
          }
          title="Improve your oral health"
          ratio={1046 / 856}
        />
        <Item
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/ingredient-1714037427767.png'
          }
          title="Natural ingredients"
          ratio={1057 / 864}
        />
        <Item
          ratio={919 / 864}
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/brighten-icon-1714037427767.png'
          }
          title="Brightens & strengthens teeth"
        />
      </SimpleGrid>
      <SimpleGrid
        data-aos="fade-up"
        columns={{ base: 2, md: 5 }}
        gap={4}
        w={{
          base: '80%',
          md: '96%'
        }}
        mt={5}
      >
        <Item
          ratio={1067 / 863}
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/protein-icon-1714037427768.png'
          }
          title="Coagulates & removes protein"
        />
        <Item
          ratio={1006 / 864}
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/five-year-icon-1714037427768.png'
          }
          title="Suitable for 5 years and above & pregnant ladies"
        />
        <Item
          ratio={1537 / 753}
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/gum-icon-1714037427769.png'
          }
          title="Prevent gum disease & bad breath"
        />
        <Item
          ratio={1011 / 864}
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/stain-icon-1714037427766.png'
          }
          title="Remove tough stains"
        />
        <Item
          ratio={1001 / 858}
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/bleaching-icon-1714037427769.png'
          }
          title="Non alcohol, non toxic, no bleaching agent"
        />
      </SimpleGrid>

      <AspectRatio
        data-aos="fade-down"
        mt={{
          base: 20,
          md: '100px'
        }}
        w={{
          base: '300px',
          sm: '300px',
          xl: '400px'
        }}
        ratio={999 / 864}
        position="relative"
      >
        <Image
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/person-bad-1714037427770.png'
          }
          alt="person bad"
          fill
        />
      </AspectRatio>
    </VStack>
  )
}

export default Effectiveness
